module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kbnslR/tc-custom/9781398445574.jpg?1705541357347",
      "alt": "This image is the cover for the book The Enemy at Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Enemy at Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After the funeral, as Jack Brown stood by the grave of his father, Bill, his eyes displayed different feelings, true feelings, of anger and disgust towards his father as he muttered, “Rot in hell you old bastard.” Jack couldn’t forgive his father for the misery he had caused him and his friend, Harold, for their arrest as deserters during World War One, when he would have known full well the penalty for desertion was the firing squad. The same went for the death of their mothers, and his sister’s escape to Canada. Will his feelings ever get resolved?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Johnson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("David Johnson has had three non-fiction books about the First World War published – One Soldier and Hitler, 1918: The Story of Henry Tandey VC DCM MM / The Man Who Didn’t Shoot Hitler: The Story of Henry Tandey VC and Adolf Hitler, 1918; Executed at Dawn: British Firing Squads on the Western Front 1914-1918; The Last Campaign of World War One (1990 – 2006): The Fight to Win Pardons for Those Executed. The Enemy at Home is his first novel to be published and again it is set in the First World War.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0